import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import {useRef} from 'react'
import useDocumentTitle from '../hooks/useDocumentTitle'
import useMetaTagContent from '../hooks/useMetaTagContent'
import useRouter from '../hooks/useRouter'
import {ForgotPasswordResType} from '../mutations/EmailPasswordResetMutation'
import {PALETTE} from '../styles/paletteV3'
import {
  CREATE_ACCOUNT_LABEL,
  CREATE_ACCOUNT_SLUG,
  SIGNIN_LABEL,
  SIGNIN_SLUG
} from '../utils/constants'
import AuthenticationDialog from './AuthenticationDialog'
import AuthPrivacyFooter from './AuthPrivacyFooter'
import DialogTitle from './DialogTitle'
import EmailPasswordAuthForm from './EmailPasswordAuthForm'
import ForgotPasswordPage from './ForgotPasswordPage'
import GoogleOAuthButtonBlock from './GoogleOAuthButtonBlock'
import HorizontalSeparator from './HorizontalSeparator/HorizontalSeparator'
import MicrosoftOAuthButtonBlock from './MicrosoftOAuthButtonBlock'
import PlainButton from './PlainButton/PlainButton'
import SubmittedForgotPasswordPage from './SubmittedForgotPasswordPage'

 














const color = PALETTE.SKY_500

const ForgotPasswordLink = styled(PlainButton)({
  color,
  fontSize: 11,
  lineHeight: '24px',
  marginTop: 8,
  textAlign: 'center',
  ':hover,:focus,:active': {
    color
  }
})

const BrandedLink = styled(PlainButton)({
  color: PALETTE.SKY_500,
  ':hover,:focus': {
    color: PALETTE.SKY_500,
    textDecoration: 'underline'
  }
})

const DialogSubTitle = styled('div')({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: 1.5,
  paddingTop: 16,
  paddingBottom: 8
})

const GenericAuthentication = (props) => {
  const {goToPage, invitationToken, page, teamName} = props
  const emailRef = useRef()
  const {location} = useRouter()
  const params = new URLSearchParams(location.search)
  const email = params.get('email')
  const authDialogRef = useRef(null)
  const getOffsetTop = () => _optionalChain([authDialogRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.offsetTop]) || 0
  const isGoogleAuthEnabled = window.__ACTION__.AUTH_GOOGLE_ENABLED
  const isMicrosoftAuthEnabled = window.__ACTION__.AUTH_MICROSOFT_ENABLED
  const isInternalAuthEnabled = window.__ACTION__.AUTH_INTERNAL_ENABLED
  const isSSOAuthEnabled = window.__ACTION__.AUTH_SSO_ENABLED

  const isCreate = page === 'create-account'
  const action = isCreate ? CREATE_ACCOUNT_LABEL : SIGNIN_LABEL
  const pageTitle = `${action} | Parabol`
  const metaCopy = isCreate
    ? 'Give structure to your meetings to get your team talking and moving forward faster. Get started in 44 seconds or less.'
    : 'Access Parabol to streamline your agile meetings. Collaborate, reflect, and grow with your team in real-time.'
  useDocumentTitle(pageTitle, action)
  useMetaTagContent(metaCopy)

  if (page === 'forgot-password') {
    return _jsx(ForgotPasswordPage, { goToPage: goToPage,} )
  }

  if (page === 'forgot-password/submitted') {
    const type = params.get('type') 
    if (type && Object.values(ForgotPasswordResType).includes(type)) {
      return _jsx(SubmittedForgotPasswordPage, { goToPage: goToPage,} )
    }
  }

  const counterAction = isCreate ? SIGNIN_LABEL : CREATE_ACCOUNT_LABEL
  const counterActionSlug = isCreate ? SIGNIN_SLUG : CREATE_ACCOUNT_SLUG
  const actionCopy = isCreate ? 'Already have an account? ' : 'New to Parabol? '
  const title = teamName ? `${teamName} is waiting` : action
  const onForgot = () => {
    goToPage('forgot-password', `?email=${_optionalChain([emailRef, 'access', _3 => _3.current, 'optionalAccess', _4 => _4.email, 'call', _5 => _5()])}`)
  }
  return (
    _jsxs(AuthenticationDialog, { ref: authDialogRef, children: [
      _jsx(DialogTitle, { children: title})
      , _jsxs(DialogSubTitle, { children: [
        _jsx('span', { children: actionCopy})
        , _jsx(BrandedLink, { onClick: () => goToPage(counterActionSlug, location.search), children: 
          counterAction
        })
      ]})
      , isGoogleAuthEnabled && (
        _jsx(GoogleOAuthButtonBlock, {
          isCreate: isCreate,
          invitationToken: invitationToken,
          getOffsetTop: getOffsetTop,}
        )
      )
      , isMicrosoftAuthEnabled && (
        _jsx(MicrosoftOAuthButtonBlock, {
          isCreate: isCreate,
          invitationToken: invitationToken,
          getOffsetTop: getOffsetTop,}
        )
      )
      , (isGoogleAuthEnabled || isMicrosoftAuthEnabled) &&
        (isInternalAuthEnabled || isSSOAuthEnabled) && (
          _jsx(HorizontalSeparator, { margin: "1rem 0 0"  , text: "or",} )
        )
      , (isInternalAuthEnabled || isSSOAuthEnabled) && (
        _jsx(EmailPasswordAuthForm, {
          email: email || '',
          isSignin: !isCreate,
          invitationToken: invitationToken,
          ref: emailRef,
          getOffsetTop: getOffsetTop,
          goToPage: goToPage,}
        )
      )
      , isCreate ? (
        _jsx(AuthPrivacyFooter, {} )
      ) : (
        isInternalAuthEnabled && (
          _jsx(ForgotPasswordLink, { onClick: onForgot, children: 'Forgot your password?'})
        )
      )
    ]})
  )
}

export default GenericAuthentication
